<template>
  <div class="col-12 col-md-6 col-lg-4 pl-0 pr-0 pl-sm-2 pr-sm-2 position-relative services-container">
    <div :class="'services-item position-relative pt-5 pb-5 initial ' + item.class_string">
      <div class="container">
        <div class="row">
          <img :src="'/img/' + item.icon_file" :alt="item.name" class="service-icon">
        </div>
        <div class="row">
          <p class="service-caption mt-4 mb-4">{{ $t(item.name) }}</p>
          <p :class="'text-block service-list'" v-html="$t(item.visible_text)"/>
          <b-button
              :class="(item.spoiler_text === '' ? 'is-hidden' : '') + (showCollapse ? '' : 'opened') + ' d-block more-link  mb-5'"
              @click="openDetail">
            {{ $t(locale.s5.moreBtn) }}
          </b-button>
        </div>
      </div>
    </div>
    <div :class="'services-item closed position-absolute pt-5 pb-0 ' + item.class_string">
      <div class="container">
        <div class="row">
          <img :src="'/img/' + item.icon_file" :alt="$t(item.name)" class="service-icon">
        </div>
        <div class="row">
          <p class="service-caption mt-4 mb-4">{{ $t(item.name) }}</p>
          <p
              :class="'text-block service-list service-spoiled ' + (showCollapse ? '' : 'no-mh ') + (!item.separate_spoiler ?  'mb-0' : '' )"
              v-html="$t(item.visible_text)"/>
          <p class="text-block service-list position-relative service-spoiled" v-html="$t(item.spoiler_text)"/>
          <div class="position-absolute button-block mt-3">
            <a href="#contacts" @click="scrollToScreen"
               class="standard-button standard-button-h60 transition d-block ml-auto mr-auto mt-3 ">
              {{ $t(item.button_text) }}
            </a>
            <b-button
                :class="(showCollapse ? '' : 'opened') + ' d-block more-link mt-4'"
                @click="closeDetail">
              {{ $t(locale.s5.collapseBtn) }}
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import "../../scss/colors";

.screen-5 {
  background-color: $white;

  .services-item {
    width: 100%;
    background-color: $white-screen;
    padding-left: 1rem;
    padding-right: 1rem;
    min-height: 520px;
    margin-top: 20px;
    z-index: 1;
    @media (min-width: 768px) {
      min-width: 344px;
    }
    @media (min-width: 992px) {
      min-width: auto;
    }
    @media (min-width: 1140px) {
      background-color: #FFFFFF;
      border: 1px solid #C4C4C4;
    }
    @media (min-width: 1200px) {
      min-width: 380px;
    }

    & + .services-item {
      margin-top: 1rem;
    }

    .standard-button {
      width: 288px;
      height: auto;
      text-align: center;
    }

    .more-link {
      bottom: 0;
      color: $gray-dark;
      text-decoration: none;
      background-color: transparent;
      border-color: transparent;
      outline: none;
      box-shadow: none;

      &:after {
        content: '';
        width: 28px;
        height: 8px;
        background-repeat: no-repeat;
        background-size: contain;
        margin-left: 10px;
        display: inline-block;
        background-image: url('/img/icon-more.svg');
      }

      &.opened {
        &:after {
          background-image: url('/img/icon-cross.svg');
        }
      }

      &:hover {
        text-decoration: none;
      }

      &:active {
        background-color: transparent;
        border-color: transparent;
        color: $gray-dark;
        outline: none;
      }
    }
  }

  .services-item.initial {
    max-height: 520px;
    background-color: $white-screen;
    @media (min-width: 1140px) {
      background-color: #FFFFFF;
    }

    .more-link {
      @media (min-width: 768px) {
        position: absolute;
      }
    }
  }

  .services-item.closed {
    top: 0;
    left: 0;
    z-index: 0 !important;
    opacity: 0;
    transition: all .3s;
  }

  .services-item.opened {
    top: 0;
    left: 0;
    z-index: 2 !important;
    opacity: 1;
    transition: all .3s;
    height: 1070px;
    background-color: $white-screen;
    @media (min-width: 576px) {
      height: 1030px;
      left: 8px;
      max-width: 524px;
    }
    @media (min-width: 768px) {
      margin-top: 0;
      height: 1060px;
      width: 344px;
      left: .5rem;
    }
    @media (min-width: 992px) {
      max-width: 314px;
      width: 100%;
    }
    @media (min-width: 1000px) {
      max-width: 318px;
      width: 100%;
    }
    @media (min-width: 1003px) {
      max-width: 320px;
      width: 100%;
    }
    @media (min-width: 1009px) {
      max-width: 321px;
      width: 100%;
    }
    @media (min-width: 1010px) {
      max-width: 322px;
      width: 100%;
    }
    @media (min-width: 1015px) {
      max-width: 323px;
      width: 100%;
    }
    @media (min-width: 1018px) {
      max-width: 324px;
      width: 100%;
    }
    @media (min-width: 1020px) {
      max-width: 326px;
      width: 100%;
    }
    @media (min-width: 1027px) {
      max-width: 327px;
      width: 100%;
    }
    @media (min-width: 1030px) {
      max-width: 330px;
      width: 100%;
    }
    @media (min-width: 1039px) {
      max-width: 331px;
      width: 100%;
    }
    @media (min-width: 1040px) {
      max-width: 333px;
      width: 100%;
    }
    @media (min-width: 1048px) {
      max-width: 334px;
      width: 100%;
    }

    @media (min-width: 1050px) {
      max-width: 335px;
      width: 100%;
    }
    @media (min-width: 1054px) {
      max-width: 337px;
      width: 100%;
    }
    @media (min-width: 1060px) {
      max-width: 338px;
      width: 100%;
    }
    @media (min-width: 1063px) {
      max-width: 339px;
      width: 100%;
    }
    @media (min-width: 1063px) {
      max-width: 340px;
      width: 100%;
    }
    @media (min-width: 1069px) {
      max-width: 341px;
      width: 100%;
    }
    @media (min-width: 1072px) {
      max-width: 342px;
      width: 100%;
    }
    @media (min-width: 1072px) {
      max-width: 344px;
      width: 100%;
    }
    @media (min-width: 1080px) {
      max-width: 347px;
      width: 100%;
    }
    @media (min-width: 1090px) {
      max-width: 350px;
      width: 100%;
    }
    @media (min-width: 1095px) {
      max-width: 351px;
      width: 100%;
    }
    @media (min-width: 1100px) {
      max-width: 352px;
      width: 100%;
    }
    @media (min-width: 1110px) {
      max-width: 356px;
    }
    @media (min-width: 1120px) {
      max-width: 360px;
      width: 100%;
    }
    @media (min-width: 1130px) {
      max-width: 364px;
      width: 100%;
    }
    @media (min-width: 1140px) {
      background-color: #FFFFFF;
      max-width: 368px;
    }
    @media (min-width: 1153px) {
      background-color: #FFFFFF;
      max-width: 370px;
    }
    @media (min-width: 1159px) {
      background-color: #FFFFFF;
      max-width: 371px;
    }
    @media (min-width: 1162px) {
      background-color: #FFFFFF;
      max-width: 373px;
    }
    @media (min-width: 1162px) {
      background-color: #FFFFFF;
      max-width: 375px;
    }
    @media (min-width: 1174px) {
      background-color: #FFFFFF;
      max-width: 377px;
    }
    @media (min-width: 1180px) {
      background-color: #FFFFFF;
      max-width: 380px;
    }
    @media (min-width: 1189px) {
      background-color: #FFFFFF;
      max-width: 382px;
    }
    @media (min-width: 1195px) {
      background-color: #FFFFFF;
      max-width: 383px;
    }
    @media (min-width: 1198px) {
      background-color: #FFFFFF;
      max-width: 384px;
    }

    /*@media (min-width: 1200px){
        max-width: 384px;
        width: 100%;
    }*/
    .button-block {
      bottom: 20px;

      .more-link {

      }
    }

    .more-link {
      &:after {
        background-image: url('/img/icon-cross.svg');
      }
    }

    &.open-to-top-768 {
      @media (min-width: 768px) {
        top: -520px;
      }
    }

    &.open-to-bottom-992 {
      @media (min-width: 992px) {
        top: 0 !important;
      }
    }

  }

  .service-spoiled {
    @media (max-width: 576px) {
      margin-bottom: 80px !important;
    }
    overflow-y: hidden;

    &.no-mh {
      overflow-y: visible;
      @media (max-width: 576px) {
        margin-bottom: 0 !important;
      }
    }
  }

  .is-hidden {
    display: none !important;
  }
}
</style>

<script>
import $ from 'jquery';
import stringsKeys from "../../i18n/strings.json";

export default {
  name: 'ServiceListItem',
  props: {
    item: {}
  },
  data: function () {
    return {
      showCollapse: true,
      locale: stringsKeys,
    }
  },
  methods: {
    scrollToScreen: function (ev) {
      ev.preventDefault();
      var screenId = ev.target.attributes.href.value;
      $([document.documentElement, document.body]).animate({
        scrollTop: $(screenId).offset().top
      }, 300);
    },
    scrollToServices(ev) {
      ev.preventDefault();
      var scrollTo = $(ev.target).parents('.services-container');
      var k = 500;
      if ($(ev.target).parents(".services-item").hasClass("prevent-scroll")) {
        k = 0;
      }
      var m = this.$mq;
      if (m == "sm" || m == "md") return;
      //if (this.$mq )
      setTimeout(function () {
        $([document.documentElement, document.body]).animate({
          scrollTop: $(scrollTo).offset().top - k
        }, 300);
      }, 100)

    },
    openDetail: function (ev) {
      ev.preventDefault();

      $(".services-item.opened").removeClass("opened").addClass("closed")
      var $target = $(ev.target);
      var $toOpen = $target.parents(".services-item").siblings(".services-item.closed");
      $toOpen.removeClass("closed").addClass("opened");
      this.scrollToServices(ev);


    },
    closeDetail: function (ev) {
      ev.preventDefault();
      var $target = $(ev.target);
      var $toClose = $target.parents(".services-item.opened");
      $toClose.removeClass("opened").addClass("closed");
    }
  }
}
</script>